import { render, staticRenderFns } from "./CommunityCell.vue?vue&type=template&id=4e3bee30&scoped=true"
import script from "./CommunityCell.vue?vue&type=script&lang=js"
export * from "./CommunityCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3bee30",
  null
  
)

export default component.exports